import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from 'react';

import { DropDownOptions } from 'devextreme-react/cjs/select-box';
//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { DateBox, SelectBox } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';
import $createDataSource from 'utils/create-data-souce-instance';
import { isSuccess } from 'utils/responseStatus';

import { useCashFlowExpenseSalaryDetailAutofillMutation } from 'bus/cash';
import { CashFlowExpenseSalaryRequestAutoFill } from 'bus/cash/types/cashFlowExpenseSalary';

type Props = {
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
  cashFlowId: number;
};

const initialForm: Omit<CashFlowExpenseSalaryRequestAutoFill, 'cashFlowId'> = {
  dateBegin: undefined,
  dateEnd: undefined,
  postId: null,
  factoryId: null,
};

const AutoFillModal: FC<Props> = ({ changeVisible, refresh, visible, cashFlowId }) => {
  const factoryDataStore: DataSource = useMemo(() => {
    const defaultFilter = ['parentId', '=', null];
    return $createDataSource('/v1/factory', 'id', { pageSize: 20, paginate: true, defaultFilter });
  }, []);

  let createGroupValidationRef = useRef<ValidationGroup>(null);
  const [posts, setPosts] = useState<any[]>([]);

  const postsDateSource = useCallback(async () => {
    const defaultFilter = [['id', '=', 2], 'or', ['id', '=', 3], 'or', ['id', '=', 1]];
    const result = await $createDataSource('/v1/post', 'id', { defaultFilter }).load();
    result.push({
      id: -1,
      name: 'Окладники',
    });
    setPosts(result);
  }, []);

  useEffect(() => {
    postsDateSource();
  }, [postsDateSource]);

  const [form, setForm] = useState<Omit<CashFlowExpenseSalaryRequestAutoFill, 'cashFlowId'>>(initialForm);

  const onHidden = () => {
    setForm(initialForm);
    createGroupValidationRef.current?.instance.reset();
  };

  const [flowExpenseSalaryDetailAutofill, { isLoading }] = useCashFlowExpenseSalaryDetailAutofillMutation();

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createGroupValidationRef.current?.instance.validate().isValid) {
      await flowExpenseSalaryDetailAutofill({ ...form, cashFlowId }).then((data) => {
        if (isSuccess(data)) {
          changeVisible(false);
          refresh();
        }
      });
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Автозаполнение"
        width={400}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createGroupValidationRef}>
                <Form id="test-facrory" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Должность" labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            items={posts}
                            displayExpr="name"
                            valueExpr="id"
                            value={form.postId}
                            onItemClick={(e) => {
                              setForm((prev) => ({ ...prev, postId: e.itemData.id }));
                            }}
                          ></SelectBox>
                        </AppFiledBox>
                        {form.postId === 2 && (
                          <AppFiledBox label="Площадка" labelTop>
                            <SelectBox
                              stylingMode="underlined"
                              dataSource={factoryDataStore}
                              displayExpr="name"
                              valueExpr="id"
                              value={form.factoryId}
                              onItemClick={(e) => {
                                setForm((prev) => ({ ...prev, factoryId: e.itemData.id }));
                              }}
                            >
                              <DropDownOptions title="Выберите Площадку" closeOnOutsideClick={true} showTitle={false} />
                            </SelectBox>
                          </AppFiledBox>
                        )}

                        <AppFiledBox label="Дата начала" labelTop>
                          <DateBox
                            stylingMode="underlined"
                            type="date"
                            onValueChange={(e) => setForm((prev) => ({ ...prev, dateBegin: e as string }))}
                            useMaskBehavior
                            dateSerializationFormat="yyyy-MM-dd"
                            value={form.dateBegin}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Дата начала" />
                            </Validator>
                          </DateBox>
                        </AppFiledBox>

                        <AppFiledBox label="Дата окончания" labelTop>
                          <DateBox
                            stylingMode="underlined"
                            type="date"
                            onValueChange={(e) => setForm((prev) => ({ ...prev, dateEnd: e as string }))}
                            useMaskBehavior
                            dateSerializationFormat="yyyy-MM-dd"
                            value={form.dateEnd}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле Дата окончания" />
                            </Validator>
                          </DateBox>
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                  disabledSubmit={isLoading}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default AutoFillModal;
